module.exports = __webpack_public_path__ + "static/media/kanemite_15sc.c00259c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/climasense/aranha_roja_tomate/curativa/kanemite_15sc.png
// module id = 2382
// module chunks = 3